import { partnerCardData } from "./partnerCardData";
import { motion } from "framer-motion";

const BecomeAPartner = () => {
  const headingVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3, delay: 0.5 } },
  };

  const cardsVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const cardItemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <div className="lg:pb-[89px] pb-[22px] md:pt-12 pt-[24px] bg-[#2B364B] text-white">
      <div className="w-[80%] mx-auto">
        <motion.h4
          className="uppercase text-center font-barlowCondensed text-[40px] md:text-[64px] leading-[110%] font-bold mb-[24px] md:mb-[56px]"
          variants={headingVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          Why Become a Partner?
        </motion.h4>
      </div>

      <motion.div
        className="flex flex-wrap justify-center gap-6 mx-[20px]"
        variants={cardsVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
      >
        {partnerCardData.map((item, index) => (
          <motion.div
            key={index}
            className="font-montserrat rounded-[10px] border border-white/[0.29] bg-white/[0.08] backdrop-blur-[110.15px] lg:w-[468px]
               md:w-[328px] w-[333px] lg:h-[305px] md:h-[297px] h-[312px] md:py-6 md:px-12 px-[30px] py-[30px]"
            variants={cardItemVariants}
            whileHover={{
              scale: 1.05,
              rotateX: 10,
              rotateY: 5,
              originX: 0.5,
              originY: 0.5,
              transition: { duration: 0.3 },
            }}
            whileTap={{
              scale: 0.95,
              transition: { duration: 0.2 },
            }}
            style={{ perspective: 2000 }}
          >
            <div className="md:w-auto md:h-auto sm:w-[65px] sm:h-[65px] w-[80px] h-[80px]">
              {item.icon}
            </div>
            <h4 className="text-[24px] leading-[110%] font-bold mt-[20px]">
              {item.title}
            </h4>
            <p className="text-sm font-medium mt-[20px]">{item.des}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default BecomeAPartner;
